// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"427":"connect","443":"about","773":"welcome","954":"calculator"}[chunkId] || chunkId) + "." + {"244":"005d534b","427":"5658012e","443":"ba41127c","773":"b7d03726","954":"6a86db9a"}[chunkId] + ".js";
};